import React from 'react'
import { BasicStatsItem } from '../index.styles'

const WeeklyIncome = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiN2M5ZjFkM2MtYWJmOS00MmJmLThiY2YtNzQ1Nzc3OTlkMTFlIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="weekly-income iframe" src={link} />
    </BasicStatsItem>
  )
}

export default WeeklyIncome